import * as React from 'react';
import { withStyle } from '../../style';
import style from './style'; // TODO: Flow doesn't seem to be picking up the default props when wrapped with
// a HOC...

/**
 * Tethered Component
 *
 * A tethered component is a component that positions itself around another
 * element on the page.  Things like tooltips and dropdown menus can be tethered
 * compoents.  This component takes in an `anchor` and renders the provided
 * children around the anchor in different locations depending on the props.
 */
export function TetheredComponent(props) {
  const {
    active,
    anchor,
    children,
    styles,
  } = props;
  return <div className={styles.root}>
    {anchor}
    {active && <div className={styles.content}>
        {children}
      </div>}
  </div>;
}
TetheredComponent.defaultProps = {
  align: 'top',
  justify: 'left',
  position: 'bottom',
  theme: 'light',
};
export default withStyle(style)(TetheredComponent);
